export default "__VITE_ASSET__BbVubAU4__"